"use client"

import { Component } from "react"
import redux from "../../common/Redux"
import API, { URL_PATH } from "../../services/API"
import { Star } from "lucide-react"
import Header from "../../components/Header"
import {
 
  CardHeader,

} from "@mui/material"
import { CustomDatePicker } from "../../components/CustomDatePicker"


class MainScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reviews: [],
      fromDate: "",
      toDate: "",
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
      loading: false,
    }
  }

  componentDidMount() {
    this.fetchReviews(1)
    // Apply fixed grid layout
    this.applyGridLayout()
    // Add resize listener
    window.addEventListener("resize", this.applyGridLayout)
    // Force re-render on resize to update form layout
    window.addEventListener("resize", () => this.forceUpdate())
  }

  componentWillUnmount() {
    // Clean up resize listeners
    window.removeEventListener("resize", this.applyGridLayout)
    window.removeEventListener("resize", () => this.forceUpdate())
  }

  applyGridLayout = () => {
    const reviewGrid = document.getElementById("reviewGrid")
    if (!reviewGrid) return

    const width = window.innerWidth

    // Responsive grid columns based on screen width
    if (width < 640) {
      reviewGrid.style.gridTemplateColumns = "1fr" // 1 column for mobile
    } else if (width < 960) {
      reviewGrid.style.gridTemplateColumns = "repeat(2, 1fr)" // 2 columns for tablets
    } else if (width < 1280) {
      reviewGrid.style.gridTemplateColumns = "repeat(3, 1fr)" // 3 columns for small desktops
    } else {
      reviewGrid.style.gridTemplateColumns = "repeat(4, 1fr)" // 4 columns for large screens
    }
  }

  handleDateChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleFilterSubmit = (e) => {
    e.preventDefault()
    this.fetchReviews(1)
  }

  fetchReviews = async (page = 1) => {
    const { fromDate, toDate } = this.state
    this.setState({ loading: true })

    try {
      const { status, message, data } = await API(
        this,
        "get",
        URL_PATH.reviews(page, fromDate, toDate),
        {},
        {},
        page === 1,
      )

      if (status === "success") {
        const { current_page, data: reviews, last_page, per_page, total } = data

        this.setState({
          reviews: current_page === 1 ? reviews : [...this.state.reviews, ...reviews],
          current_page,
          last_page,
          per_page,
          total,
          loading: false,
        })

        // Apply grid layout after data is loaded
        setTimeout(this.applyGridLayout, 0)
        return
      }

      if (status === "error") {
        this.props.okDialog(message)
      } else {
        this.props.okDialog("Something went wrong")
      }
    } catch (error) {
      console.error("Error fetching reviews:", error)
      this.props.okDialog("An error occurred while fetching reviews")
    } finally {
      this.setState({ loading: false })
    }
  }

  loadMoreReviews = () => {
    const { current_page, last_page } = this.state
    if (current_page < last_page) {
      this.fetchReviews(current_page + 1)
    }
  }

  renderStars = (count) => {
    return (
      <div style={{ display: "flex", gap: "2px" }}>
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={20} fill={i < count ? "#FFC857" : "transparent"} color="#FFC857" />
        ))}
      </div>
    )
  }
  renderEmptyState = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px",
          border: "2px dashed #FCD34D",
          borderRadius: "12px",
          backgroundColor: "#041A29",
          // padding: "32px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            marginBottom: "20px",
            color: "#FFC857",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: "100%", height: "100%" }}
          >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
          </svg>
        </div>
        <h3
          style={{
            fontSize: "22px",
            fontWeight: "600",
            color: "#FFFFFF",
            marginBottom: "12px",
          }}
        >
          No Feedbacks Yet
        </h3>
        <p
          style={{
            fontSize: "16px",
            color: "#CCCCCC",
            textAlign: "center",
            maxWidth: "320px",
            lineHeight: "1.5",
          }}
        >
          Feedbacks from your customers will show up here once they're submitted.
        </p>
      </div>
    )
  }

  render() {
    const { reviews, fromDate, toDate, current_page, last_page, loading } = this.state

    const containerStyle = {
      margin: "0 auto",
      padding: window.innerWidth < 640 ? "16px" : "24px",
      backgroundColor: "none",
      borderRadius: "16px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    }

    const headerStyle = {
      fontSize: "24px",
      fontWeight: "bold",
      // marginBottom: "32px",
      color: "#FFFFFF",
      // borderBottom: "3px solid #FFC857",
      paddingBottom: "12px",
      display: "inline-block",
    }

    const formContainerStyle = {
      marginBottom: "36px",
    }

    const formTitleStyle = {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "20px",
      color: "#FFFFFF",
    }

    const formRowStyle = {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "16px",
    }

    const formGroupStyle = {
      flex: "1",
    }

    const labelStyle = {
      display: "block",
      fontSize: "15px",
      fontWeight: "500",
      marginBottom: "8px",
      color: "#FFFFFF",
    }

    const inputStyle = {
      width: "100%",
      padding: "10px 14px",
      border: "1px solid #757575",
      backgroundColor: "#02111B",
      color: "#FFFFFF",
      borderRadius: "8px",
      outline: "none",
      maxWidth: "220px",
      minWidth: "180px",
    }

    const buttonStyle = {
      padding: "12px 24px",
      backgroundColor: "#FFC857",
      color: "black",
      borderRadius: "8px",
      border: "none",
      fontWeight: "600",
      cursor: "pointer",
      marginTop: "24px",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    }

    // Fixed grid container with 4 columns
    const gridContainerStyle = {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "20px",
    }

    // Updated card style with enhanced styling
    const cardStyle = {
      borderLeft: " solid #FFC857",
      padding: window.innerWidth < 640 ? "16px" : "20px",
      transition: "transform 0.2s ease",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }

    const cardHeaderStyle = {
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
    }

    const avatarStyle = {
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "14px",
      color: "#072A40",
      fontWeight: "bold",
      backgroundColor: "#FFC857",
      fontSize: "18px",
    }

    const userInfoStyle = {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }

    const userNameStyle = {
      fontWeight: "600",
      color: "#FFFFFF",
      fontSize: "16px",
    }

    const dateStyle = {
      fontSize: "13px",
      color: "#AAAAAA",
      marginTop: "4px",
    }

    const starsStyle = {
      marginBottom: "16px",
      // fontSize: "20px",
      // color: "#FFC857",
      // letterSpacing: "2px",
    }

    const reviewContentStyle = {
      // borderTop: "1px solid #1E3A4F",
      // paddingTop: "16px",
      // marginTop: "12px",
      fontSize: "15px",
      color: "#DDDDDD",
      lineHeight: "1.5",
      flex: "1",
    }

    const loadMoreContainerStyle = {
      marginTop: "36px",
      textAlign: "center",
    }

    const loadMoreButtonStyle = {
      padding: "12px 28px",
      backgroundColor: "#FFC857",
      color: "#072A40",
      fontWeight: "600",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      transition: "all 0.2s ease",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      fontSize: "16px",
    }

    const noMoreStyle = {
      marginTop: "36px",
      textAlign: "center",
      color: "#AAAAAA",
      fontSize: "16px",
      fontStyle: "italic",
    }

    return (
      <div style={containerStyle}>
        {/* CSS to hide scrollbars while keeping functionality */}
        <style>
          {`
            /* Hide scrollbar for Chrome, Safari and Opera */
            *::-webkit-scrollbar {
              display: none;
            }
            
            /* Hide scrollbar for IE, Edge and Firefox */
            * {
              -ms-overflow-style: none;  /* IE and Edge */
              scrollbar-width: none;  /* Firefox */
            }
            
            /* Ensure body and html still scroll */
            html, body {
              overflow-y: auto;
            }
          `}
        </style>

        {/* Date filter form */}
        <form onSubmit={this.handleFilterSubmit} style={formContainerStyle}>
          <div>
            <div
              style={{
                display: "flex",
              
                justifyContent: "space-between",
                flexDirection: window.innerWidth < 768 ? "column" : "row",
                gap: "24px",
              }}
            >
              {/* Title on the left */}
             
               <CardHeader
            title={
              <Header title="Customer Feedback" />

            }
            sx={{ pb: 2 }}
          />

              {/* Date filters on the right */}
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "center",
                  flexWrap: "wrap",
                  justifyContent: window.innerWidth < 768 ? "flex-start" : "flex-end",
                }}
              >
               <div style={formGroupStyle}>
  <CustomDatePicker
    label="Start Date"
    value={fromDate}
    onChange={this.handleDateChange}
    name="fromDate"
    sx={{
      '& .MuiInputBase-root': {
        backgroundColor: '#02111B',
        color: '#FFFFFF',
        border: '1px solid #757575',
        borderRadius: '8px',
      },
      '& .MuiInputLabel-root': {
        color: '#FFFFFF',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#757575',
      },
    }}
  />
</div>

<div style={formGroupStyle}>
  <CustomDatePicker
    label="End Date"
    value={toDate}
    onChange={this.handleDateChange}
    name="toDate"
    sx={{
      '& .MuiInputBase-root': {
        backgroundColor: '#02111B',
        color: '#FFFFFF',
        border: '1px solid #757575',
        borderRadius: '8px',
      },
      '& .MuiInputLabel-root': {
        color: '#FFFFFF',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#757575',
      },
    }}
  />
</div>


                <button
                  type="submit"
                  style={{
                    ...buttonStyle,
                    marginTop: window.innerWidth < 768 ? "24px" : "0",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#FFD57A")}
                  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FFD57A")}
                >
                  Apply Filter
                </button>
              </div>
            </div>
          </div>
        </form>

        {/* Reviews grid - fixed to always show 4 columns */}
        {reviews.length === 0 ? (
          this.renderEmptyState()
        ) : (
          <>
            <div id="reviewGrid" style={gridContainerStyle}>
              {reviews.map((review) => (
                <div
                  key={review.id}
                  style={{
                    backgroundColor: "#041A29 ",
                    borderLeft: " solid #FFC857",
                    padding: "20px",
                    // backgroundColor: "#072A40",

                    transition: "transform 0.2s ease",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                  onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                >
                  <div style={cardHeaderStyle}>
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",  // Add this
                      alignItems: "center"  // Add this for vertical alignment
                    }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
  <div style={userNameStyle}>{review.user?.name || "Anonymous"}</div>
  {this.renderStars(review.stars)}
</div>
                      <div style={starsStyle}>
                      <div style={dateStyle}>{new Date(review.created_at).toLocaleDateString()}</div>

                      </div>
                    </div>
                  </div>



                  <div style={reviewContentStyle}>{review.description}</div>
                </div>
              ))}
            </div>

            {/* Load more button */}
            {current_page < last_page && (
              <div style={loadMoreContainerStyle}>
                <button
                  onClick={this.loadMoreReviews}
                  style={loadMoreButtonStyle}
                  disabled={loading}
                  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#FFD57A")}
                  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#FFD57A")}
                >
                  {loading ? "Loading..." : "Load More Reviews"}
                </button>
              </div>
            )}

            {current_page === last_page && reviews.length > 0 && (
              <div style={noMoreStyle}>You've reached the end of all reviews</div>
            )}
          </>
        )}
      </div>
    )
  }
}

export default redux(MainScreen)
